export default __webpack_public_path__ + "static/media/server.94ac0ff4.png";